export const FREE_SHIPPING_MINIMUM = 30;
